import { useContext } from 'react';
import { createNamedContext } from '@utils';

export type CardContextValueType = {
  closeCard: () => void;
};

export const CardContext = createNamedContext<CardContextValueType | undefined>(undefined, 'CardContext');

export const useCardContext = () => useContext(CardContext);